var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4163",
    "data-name": "Group 4163",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144.23,
    height: 122.997,
    viewBox: "0 0 144.23 122.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2450",
    "data-name": "Group 2450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    transform: "translate(14.408 13.953)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    transform: "translate(25.479 13.953)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 3.792,
    cy: 3.792,
    r: 3.792,
    transform: "translate(36.399 13.953)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1674",
    "data-name": "Path 1674",
    d: "M136.568,9.5H12.51A10,10,0,0,0,2.5,19.51V122.488A10,10,0,0,0,12.51,132.5H136.72a10,10,0,0,0,10.01-10.01V19.51A10.231,10.231,0,0,0,136.568,9.5ZM12.51,17.235H136.72a2.332,2.332,0,0,1,2.275,2.275V37.254H10.235V19.51A2.332,2.332,0,0,1,12.51,17.235ZM136.568,124.611H12.51a2.332,2.332,0,0,1-2.275-2.275v-77.5H138.843v77.5A2.332,2.332,0,0,1,136.568,124.611Z",
    transform: "translate(-2.5 -9.5)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1675",
    "data-name": "Path 1675",
    d: "M38.647,63.4l4.247-4.247L47.14,63.4a4.041,4.041,0,0,0,5.46,0,3.845,3.845,0,0,0,0-5.46l-4.247-4.247L52.6,49.447a3.861,3.861,0,0,0-5.46-5.46l-4.247,4.247-4.247-4.247a3.861,3.861,0,0,0-5.46,5.46l4.247,4.247L33.187,57.94a3.845,3.845,0,0,0,0,5.46,4.041,4.041,0,0,0,5.46,0Z",
    transform: "translate(12.766 7.729)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1676",
    "data-name": "Path 1676",
    d: "M74.2,44.087a3.845,3.845,0,0,0-5.46,0l-4.247,4.247-4.247-4.247a3.861,3.861,0,0,0-5.46,5.46l4.247,4.247L54.787,58.04a3.845,3.845,0,0,0,0,5.46,4.041,4.041,0,0,0,5.46,0l4.247-4.247L68.74,63.5a4.041,4.041,0,0,0,5.46,0,3.845,3.845,0,0,0,0-5.46l-4.246-4.4L74.2,49.4A3.664,3.664,0,0,0,74.2,44.087Z",
    transform: "translate(23.925 7.781)",
    fill: "#121e59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1677",
    "data-name": "Path 1677",
    d: "M58.335,61.4A26.415,26.415,0,0,0,34.221,77.173,3.8,3.8,0,0,0,41.2,80.206a18.351,18.351,0,0,1,33.82,0,3.744,3.744,0,0,0,3.488,2.275,5.389,5.389,0,0,0,1.517-.3,3.717,3.717,0,0,0,1.972-5A25.315,25.315,0,0,0,58.335,61.4Z",
    transform: "translate(13.704 17.312)",
    fill: "#121e59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c80f28a094d006bcebb4aa8dae179b60.svg";
export { ForwardRef as ReactComponent };